// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {

  production: false,
  /*endPoint: 'http://localhost:8082',
  header_home1: 'Bienvenido al sistema del Labarotorio de Análisis Clínicos',
  header_home2: 'Hospital Naval Cirujano Mayor Dr. Pedro Mayo', // PERMITE HTML
  header_home3: '', // PERMITE HTML*/

  endPoint: window['endPoint'] || 'http://localhost:8082',

  header_home1: window['header_home1'] || '',
  header_home2: window['header_home2'] || '', // PERMITE HTML
  header_home3: window['header_home3'] || '',// PERMITE HTML

  login_labo_logo: window['login_labo_logo'],
  login_labo_title: window['login_labo_title'],
  login_dedalus_logo: window['login_dedalus_logo'],
  show_disabled_modules: window['show_disabled_modules'],
  show_grid_result_config: window['show_grid_result_config'],
  show_previous_result_config: window['show_previous_result_config'],
  show_alerts: window['show_alerts'],
  color_report_complete: window['color_report_complete'],  
  color_report_partial: window['color_report_partial'],  
  hc_label: window['hc_label']

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
